export default "__VITE_ASSET__ylz1aXGm__"